/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import AccountComponent from './main';


export const account = (context, next) => {
    context.primary = <AccountComponent />;
    next();
};
